var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.21 14.8274C6.31617 15.7415 7.19438 16.6162 8.10844 16.7259C10.3429 16.9649 12.5965 16.9649 14.831 16.7259C15.7451 16.6197 16.6198 15.7415 16.7295 14.8274C16.9685 12.593 16.9685 10.3393 16.7295 8.10487C16.6233 7.1908 15.7451 6.31612 14.831 6.20994C12.5966 5.97018 10.3429 5.97018 8.10844 6.20994C7.19438 6.31612 6.31969 7.19432 6.21352 8.10838C5.97284 10.3415 5.97166 12.594 6.21 14.8274Z",
    fill: "url(#paint0_linear_150_4188)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7907 8.10487C29.6845 7.1908 28.8063 6.31612 27.8958 6.20994C25.6613 5.97018 23.4076 5.97018 21.1732 6.20994C20.2591 6.31612 19.3845 7.19432 19.2783 8.10838C19.0392 10.3429 19.0392 12.5965 19.2783 14.831C19.3845 15.745 20.2627 16.6197 21.1732 16.7294C23.4077 16.9685 25.6613 16.9685 27.8958 16.7294C28.8098 16.6232 29.6845 15.745 29.7907 14.831C30.0307 12.5954 30.0307 10.3405 29.7907 8.10487Z",
    fill: "url(#paint1_linear_150_4188)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7907 21.1733C29.6845 20.2592 28.8063 19.3845 27.8958 19.2783C25.6613 19.0393 23.4077 19.0393 21.1732 19.2783C20.2591 19.3845 19.3845 20.2627 19.2783 21.1733C19.0392 23.4077 19.0392 25.6614 19.2783 27.8958C19.3845 28.8099 20.2627 29.6846 21.1732 29.7908C23.4076 30.0305 25.6613 30.0305 27.8958 29.7908C28.8098 29.6846 29.6845 28.8064 29.7907 27.8958C30.0305 25.6614 30.0305 23.4077 29.7907 21.1733Z",
    fill: "url(#paint2_linear_150_4188)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8275 19.2783C12.593 19.0393 10.3394 19.0393 8.10493 19.2783C7.19086 19.3845 6.31618 20.2627 6.21 21.1733C5.97024 23.4077 5.97024 25.6614 6.21 27.8958C6.31618 28.8099 7.19438 29.6846 8.10844 29.7908C10.3429 30.0305 12.5966 30.0305 14.831 29.7908C15.7451 29.6846 16.6198 28.8064 16.7295 27.8958C16.9685 25.6614 16.9685 23.4077 16.7295 21.1733C16.6163 20.2599 15.7409 19.3845 14.8275 19.2783Z",
    fill: "url(#paint3_linear_150_4188)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_150_4188",
    x1: 16.0836,
    y1: 16.0744,
    x2: 6.86369,
    y2: 6.84731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23438F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_150_4188",
    x1: 29.1459,
    y1: 16.0776,
    x2: 19.923,
    y2: 6.85471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23438F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_150_4188",
    x1: 29.1458,
    y1: 29.14,
    x2: 19.9288,
    y2: 19.9173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23438F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBDAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_150_4188",
    x1: 16.0835,
    y1: 29.14,
    x2: 6.86653,
    y2: 19.9113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23438F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBDAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuM);
export default __webpack_public_path__ + "static/media/menu_m.8f86b0e04ff25b8c8323d0fb47907c2d.svg";
export { ForwardRef as ReactComponent };